<template>
  <div class="block">
    <BarraNavigazione
      @voce-menu-selezionata="gesticiSelezioneMenu"/>
  </div>
  <LoginForm  v-if="!credenzialiUtente"/>
  <PaginaHome v-if="statoInterfaccia.elementoVisibile=='Home' && credenzialiUtente"/>
  <PaginaAbout v-if="statoInterfaccia.elementoVisibile=='About' && credenzialiUtente"/>
  <ElencoClienti v-if="statoInterfaccia.elementoVisibile=='ElencoClienti' && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaClienti
    :campi-da-cercare="statoInterfaccia.campiRicercaClienti?statoInterfaccia.campiRicercaClienti:null"
    :bottone-aggiungi-visibile=true
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <ElencoLeads v-if="statoInterfaccia.elementoVisibile=='ElencoLeads' && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaLeads
    :campi-da-cercare=statoInterfaccia.campiRicercaLeads
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <ElencoLavori v-if="statoInterfaccia.elementoVisibile=='ElencoLavori' && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaLavori
    :campi-da-cercare=statoInterfaccia.campiRicercaLavori
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <ElencoFasi v-if="statoInterfaccia.elementoVisibile=='ElencoFasi' && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaFasi
    :soloGiorniSquadra=statoInterfaccia.soloFasiConGiorniSquadra
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <ElencoDico v-if="statoInterfaccia.elementoVisibile=='ElencoDico' && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaDico
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <ElencoPreventivi v-if="statoInterfaccia.elementoVisibile=='ElencoPreventivi' && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaPreventivi
    :campi-da-cercare=statoInterfaccia.campiRicercaPreventivi
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormCosto v-if="statoInterfaccia.elementoVisibile=='FormCosto' && credenzialiUtente"
    :id-cliente=statoInterfaccia.idCliente
    :id-lavoro=statoInterfaccia.idLavoro
    :id-costo=statoInterfaccia.idCosto
    :titolo-visibile=true
    vista="subordinata"
    @modificaElementoInCorso="bloccaVisualizzazione"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <ElencoCosti v-if="(statoInterfaccia.elementoVisibile=='ElencoCosti' || statoInterfaccia.elementoVisibile=='FormCosto') && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaCosti
    :data-inizio=statoInterfaccia.dataInizioRicercaCosti
    :data-fine=statoInterfaccia.dataFineRicercaCosti
    :bottone-aggiungi-visibile=true
    :titolo-visibile="statoInterfaccia.elementoVisibile=='FormCosto'? false: true"
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <ElencoContatti v-if="statoInterfaccia.elementoVisibile=='ElencoContatti' && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaContatti
    :bottone-aggiungi-visibile=true
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <ElencoListini v-if="statoInterfaccia.elementoVisibile=='ElencoListini' && credenzialiUtente"
    :testo-da-cercare=statoInterfaccia.testoRicercaListini
    :listinoAttivo=statoInterfaccia.listinoAttivo
    :bottone-aggiungi-visibile=true
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormCliente v-if="statoInterfaccia.elementoVisibile=='FormCliente' && credenzialiUtente"
    :id-cliente=statoInterfaccia.idCliente
    @modificaElementoInCorso="bloccaVisualizzazione"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormLead v-if="statoInterfaccia.elementoVisibile=='FormLead' && credenzialiUtente"
    :id-cliente=statoInterfaccia.idCliente
    :id-lead=statoInterfaccia.idLead
    @modificaElementoInCorso="bloccaVisualizzazione"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormPreventivo v-if="statoInterfaccia.elementoVisibile=='FormPreventivo' && credenzialiUtente"
    :id-cliente=statoInterfaccia.idCliente
    :id-lead=statoInterfaccia.idLead
    :id-preventivo=statoInterfaccia.idPreventivo
    :sezione-voce-preventivo=statoInterfaccia.sezioneVocePreventivo
    @modificaElementoInCorso="bloccaVisualizzazione"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormLavoro v-if="statoInterfaccia.elementoVisibile=='FormLavoro' && credenzialiUtente"
    :id-cliente=statoInterfaccia.idCliente
    :id-lavoro=statoInterfaccia.idLavoro
    @modificaElementoInCorso="bloccaVisualizzazione"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormDico v-if="statoInterfaccia.elementoVisibile=='FormDico' && credenzialiUtente"
    :id-cliente=statoInterfaccia.idCliente
    :id-lavoro=statoInterfaccia.idLavoro
    :id-dico=statoInterfaccia.idDico
    @modificaElementoInCorso="bloccaVisualizzazione"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormFase v-if="statoInterfaccia.elementoVisibile=='FormFase' && credenzialiUtente"
    :id-cliente=statoInterfaccia.idCliente
    :id-lavoro=statoInterfaccia.idLavoro
    :id-fase=statoInterfaccia.idFase
    @modificaElementoInCorso="bloccaVisualizzazione"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormContatto v-if="statoInterfaccia.elementoVisibile=='FormContatto' && credenzialiUtente"
    :id-contatto=statoInterfaccia.idContatto
    @modificaElementoInCorso="bloccaVisualizzazione"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <FormArticoloListino v-if="statoInterfaccia.elementoVisibile=='FormArticoloListino' && credenzialiUtente"
    :idArticolo=statoInterfaccia.idArticoloListino
    :idListino=statoInterfaccia.idListino
    @modificaElementoInCorso="bloccaVisualizzazione"
    @statoInterfacciaCambiato="cambiaStatoInterfaccia"
    @elementoSelezionato="gestisciSelezioneElemento"/>
  <PaginaTemplate v-if="statoInterfaccia.elementoVisibile=='PaginaTemplate' && credenzialiUtente"/>
  <PaginaSviluppo v-if="statoInterfaccia.elementoVisibile=='PaginaSviluppo' && credenzialiUtente"/>
  <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>
</template>

<script setup>
  import BarraNavigazione from './components/BarraNavigazione.vue';
  import LoginForm from './components/FormLogin.vue';
  import ElencoClienti from './components/ElencoClienti.vue';
  import ElencoLeads from './components/ElencoLeads.vue';
  import ElencoLavori from './components/ElencoLavori.vue';
  import ElencoFasi from './components/ElencoFasi.vue';
  import ElencoDico from './components/ElencoDico.vue';
  import ElencoPreventivi from './components/ElencoPreventivi.vue';
  import ElencoContatti from './components/ElencoContatti.vue';
  import ElencoListini from './components/ElencoListini.vue';
  import ElencoCosti from './components/ElencoCosti.vue';
  import FormCliente from './components/FormCliente.vue';
  import FormLead from './components/FormLead.vue';
  import FormPreventivo from './components/FormPreventivo.vue';
  import FormLavoro from './components/FormLavoro.vue';
  import FormDico from './components/FormDico.vue';
  import FormFase from './components/FormFase.vue';
  import FormContatto from './components/FormContatto.vue';
  import FormArticoloListino from './components/FormArticoloListino.vue';
  import FormCosto from './components/FormCosto.vue';
  import PaginaTemplate from './components/PaginaTemplate.vue';
  import PaginaSviluppo from './components/PaginaSviluppo.vue';
  import PaginaAbout from './components/PaginaAbout.vue';
  import PaginaHome from './components/PaginaHome.vue';
  import MessaggioModale from "./components/MessaggioModale.vue";
  import { ref, nextTick } from 'vue';
  import { credenzialiUtente } from './code/firebase';
  import { statoInterfaccia } from './code/utilita';

  // export const statoInterfaccia = ref({elementoVisibile: "Home"});      // Contiene lo stato dell'interfaccia dei vari componenti
  const messaggioModale = ref(null);                                    // null = Non mostrare il messaggio modale

  function gesticiSelezioneMenu(voce) {
    if (!statoInterfaccia.value.bloccoAttivo) {
      statoInterfaccia.value.elementoVisibile = voce;
    } else {
      messaggioModale.value = {
          testoLight:{testo:'Ok', comando:'annulla'},
          testoPrimary:null,
          testoDanger:null,
          messaggio:"Per proseguire devi salvare o annullare le modifiche."
      };
    }
  }

  async function gestisciSelezioneElemento(elementoSelezionato) {
    switch (elementoSelezionato.tipo) {
      case 'cliente':
        if (statoInterfaccia.value.elementoVisibile == 'FormCliente') {
          statoInterfaccia.value.elementoVisibile = null;
          await nextTick();
        }
        statoInterfaccia.value['idCliente'] = elementoSelezionato.idCliente;
        statoInterfaccia.value.elementoVisibile = 'FormCliente';
        break;
      case 'clienti':
        statoInterfaccia.value.elementoVisibile = 'ElencoClienti';
        break;
      case 'lead':
        if (statoInterfaccia.value.elementoVisibile == 'FormLead') {
            statoInterfaccia.value.elementoVisibile = null;
            await nextTick();
        }
        statoInterfaccia.value['idCliente'] = elementoSelezionato.idCliente;
        statoInterfaccia.value['idLead'] = elementoSelezionato.idLead;
        statoInterfaccia.value.elementoVisibile = 'FormLead';
        break;
      case 'leads':
        statoInterfaccia.value.elementoVisibile = 'ElencoLeads';
        break;
      case 'preventivo':
        if (statoInterfaccia.value.elementoVisibile == 'FormPreventivo') {
            statoInterfaccia.value.elementoVisibile = null;
            await nextTick();
        }
        statoInterfaccia.value['idCliente'] = elementoSelezionato.idCliente;
        statoInterfaccia.value['idLead'] = elementoSelezionato.idLead;
        statoInterfaccia.value['idPreventivo'] = elementoSelezionato.idPreventivo;
        statoInterfaccia.value['sezioneVocePreventivo'] = elementoSelezionato.sezioneVocePreventivo;
        statoInterfaccia.value.elementoVisibile = 'FormPreventivo';
        break;
      case 'preventivi':
        statoInterfaccia.value.elementoVisibile = 'ElencoPreventivi';
        break;
      case 'contatto':
        statoInterfaccia.value['idContatto'] = elementoSelezionato.idContatto;
        statoInterfaccia.value.elementoVisibile = 'FormContatto';
        break;
      case 'contatti':
        statoInterfaccia.value.elementoVisibile = 'ElencoContatti';
        break;
      case 'lavoro':
        if (statoInterfaccia.value.elementoVisibile == 'FormLavoro') {
          statoInterfaccia.value.elementoVisibile = null;
          await nextTick();
        }
        statoInterfaccia.value['idCliente'] = elementoSelezionato.idCliente;
        statoInterfaccia.value['idLavoro'] = elementoSelezionato.idLavoro;
        statoInterfaccia.value.elementoVisibile = 'FormLavoro';
        break;
      case 'lavori':
        statoInterfaccia.value.elementoVisibile = 'ElencoLavori';
        break;

      case 'dico':
        if (statoInterfaccia.value.elementoVisibile == 'FormDico') {
            statoInterfaccia.value.elementoVisibile = null;
            await nextTick();
        }
        statoInterfaccia.value['idCliente'] = elementoSelezionato.idCliente;
        statoInterfaccia.value['idLavoro'] = elementoSelezionato.idLavoro;
        statoInterfaccia.value['idDico'] = elementoSelezionato.idDico;
        statoInterfaccia.value.elementoVisibile = 'FormDico';
        break;
      case 'dicos':
        statoInterfaccia.value.elementoVisibile = 'ElencoDico';
        break;
      case 'fase':
        if (statoInterfaccia.value.elementoVisibile == 'FormFase') {
            statoInterfaccia.value.elementoVisibile = null;
            await nextTick();
        }
        statoInterfaccia.value['idCliente'] = elementoSelezionato.idCliente;
        statoInterfaccia.value['idLavoro'] = elementoSelezionato.idLavoro;
        statoInterfaccia.value['idFase'] = elementoSelezionato.idFase;
        statoInterfaccia.value.elementoVisibile = 'FormFase';
        break;
      case 'fasi':
        statoInterfaccia.value.elementoVisibile = 'ElencoFasi';
        break;
      case 'costo':
        if (statoInterfaccia.value.elementoVisibile == 'FormCosto') {
            statoInterfaccia.value.elementoVisibile = null;
            await nextTick();
        }
        statoInterfaccia.value['idCliente'] = elementoSelezionato.idCliente;
        statoInterfaccia.value['idLavoro'] = elementoSelezionato.idLavoro;
        statoInterfaccia.value['idCosto'] = elementoSelezionato.idCosto;
        statoInterfaccia.value.elementoVisibile = 'FormCosto';
        break;
      case 'costi':
        if (statoInterfaccia.value.elementoVisibile == 'ElencoCosti' || statoInterfaccia.value.elementoVisibile == 'FormCosto') {
            statoInterfaccia.value.elementoVisibile = null;
            await nextTick();
        }
        statoInterfaccia.value.elementoVisibile = 'ElencoCosti';
        break;
      case 'articoloListino':
        statoInterfaccia.value.elementoVisibile = null;
        await nextTick();
        statoInterfaccia.value['idListino'] = elementoSelezionato.idListino;
        statoInterfaccia.value['idArticoloListino'] = elementoSelezionato.idArticoloListino;
        statoInterfaccia.value.elementoVisibile = 'FormArticoloListino';
        break;
      case 'listini':
        statoInterfaccia.value.elementoVisibile = 'ElencoListini';
        break;
    }
  }

  async function cambiaStatoInterfaccia(tempStato) {
    // Cabia lo stato dell'interfaccia
    // spengo e riaccendo il componente interessato per aggiornarlo
    let tmp = statoInterfaccia.value.elementoVisibile;
    statoInterfaccia.value.elementoVisibile = 'null';
    Object.assign(statoInterfaccia.value, tempStato);
    await nextTick();
    statoInterfaccia.value.elementoVisibile = tmp;
  }

  function bloccaVisualizzazione(stato) {
    statoInterfaccia.value['bloccoAttivo'] = stato;
  }

  function bComandoModale(comando) {
    switch (comando) {
      case 'annulla':
        messaggioModale.value = null;
        break;
    }
  }

</script>